// Home to display "Pregunta"
import { VFQuestion } from './VFQuestion';
export const QuestionVF = (optionsQuestion, handlerRadioClick, handlerInfoClick, cursoColor, transTxt, audioQuestion, activeButton, questionDes) => {
    let options;
    if(optionsQuestion!==''){
        // console.log(optionsQuestion)
        options = optionsQuestion.map((element, id) => {
            let defChk =(id===0)?1:0
            let cart = [];
            element.defChk = defChk;
            cart.push(element);
            return <VFQuestion 
                key={`v${ element.id }`}
                
                { ...cart[0]}
            />
        });
        const audioQ = (audioQuestion) => {
            if(audioQuestion){
                return(
                    <div>
                        <audio controls>
                            <source src={process.env.REACT_APP_ADMIN_URL+audioQuestion} type="audio/mpeg"></source>
                        </audio>
                    </div>
                )
            }
            
        }
        const actBut = (activeButton) => {
            if(activeButton===true){
                return( <button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary btn-question-p" onClick={handlerRadioClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}}>{transTxt.btn.enviar.txt}</button>)
            }
            return (<button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary btn-question-p" onClick={handlerInfoClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}}>{transTxt.btn.regresar.txt}</button>);
            
        }
        // console.log('questionDes',questionDes)
        return (<>
            {audioQ(audioQuestion)}
            <div className="question-description">
                {questionDes}
                {/* <form className="verdadero-falso"> */}

                <div className="btn-group-radio" data-toggle="buttons">
                    {options}
                </div>

                
                <div className="course-enter-q">
                    <br/>
                    <br/>
                    {actBut(activeButton)}
                    <br/>
                    <br/>
                </div>
            </div>
            </>);
        
    }
    return null;
            
        
}

